import $ from 'jquery';

import FormUtils from 'chairisher/util/form';

import { getAccountAddressEndpoint } from 'chairisher/context/account';

const AccountAddressViewHelper = {
    /**
     * Binds the hide action for the address line 2 button
     *
     * @param {jQuery} $form The form element containing the address line 2 button
     */
    bindStreetAddressLine2BtnCollapse($form) {
        $form.on('click', '.js-btn-collapse', (e) => $(e.currentTarget).addClass('hidden'));
    },

    /**
     * Resets the address form fields and error states
     *
     * @param {jQuery} $form The form element containing the fields to be reset
     */
    resetForm($form) {
        $form.attr({
            action: getAccountAddressEndpoint(),
            method: 'post',
        });
        $form.get(0).reset();
        $form.find(':disabled').prop('disabled', false);
        $form.find('.js-form-group.type').removeClass('hidden');
        AccountAddressViewHelper.toggleStreetAddressLine2($form, false);
        FormUtils.clearFormErrors($form);
    },

    /**
     * Sets the errors on the address form
     *
     * @param {jQuery} $form The form element on which to set the errors
     * @param {Object.<string, Array.<string>} errorsObj An object containing the errors to be set
     */
    setFormErrors($form, errorsObj) {
        FormUtils.addFormErrors($form, errorsObj);
    },

    /**
     * Toggles the visibility of street address line 2 by hiding the button and displaying the field (and vice-versa)
     *
     * @param {jQuery} $form The form element containing the button and field
     * @param {boolean} shouldShow Whether or not the street address line 2 field should be shown
     */
    toggleStreetAddressLine2($form, shouldShow) {
        $form.find('.js-btn-collapse').toggleClass('hidden', shouldShow);
        $form.find('.street_address_line_2').collapse(shouldShow ? 'show' : 'hide');
    },
};

export default AccountAddressViewHelper;
